module.exports = __webpack_public_path__ + "static/img/oprCt_bg_05.9c8de838.svg";